module.exports = __webpack_public_path__ + "static/media/doc07.72006478.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/doc07.png
// module id = 59
// module chunks = 0